import FormatsTime from "./formats-time";
import FormatsDate from "./formats-date";
import { sortBy } from "../utils";
import SortingType from "../enum/sorting-type";

const FormatsDateTime: string[] = [...FormatsDate];

FormatsDate.forEach((dateFormat: string) => {
    FormatsTime.forEach((timeFormat: string) => {
        FormatsDateTime.push(`${dateFormat} ${timeFormat}`);
    });
});

sortBy(FormatsDateTime, 'length', SortingType.Descending);

export default FormatsDateTime;